import { OFFER_IMAGE_ASPECT } from 'components/offers/offerImages'

export const OFFER_FRAME_SCALE = 0.85

// Use the available editor space, not the source resolution, for preview geometry.
export const getCropLayout = (editor, source, offerMode, cropAspect = 1) => {
  if (!editor?.width || !editor?.height || !source?.width || !source?.height) return null
  const aspect = source.width / source.height
  const width = Math.min(editor.width, editor.height * aspect)
  const height = width / aspect
  const frameAspect = offerMode ? OFFER_IMAGE_ASPECT : cropAspect
  const frameWidth = Math.min(width, height * frameAspect) * (offerMode ? OFFER_FRAME_SCALE : 1)
  const cropSize = { width: frameWidth, height: frameWidth / frameAspect }
  return {
    objectFit: aspect >= editor.width / editor.height ? 'horizontal-cover' : 'vertical-cover',
    cropSize,
    minZoom: offerMode ? Math.min(cropSize.width / width, cropSize.height / height) : 1,
  }
}
